import { Option } from '@sapphire/result';

import {
  SurveyQuota,
  UNKNOWN_QUOTA_GROUP_KEY,
} from '../../models/survey-quota.model';

/**
 * A qualification created after the survey launched can't retroactively
 * account for completes gathered before it existed, so its quotas' fielded
 * counts never add up to the survey total. Legacy synthesizes a read-only
 * "Unknown" row to absorb the gap — manage-quotas.component.ts:998-1057
 * (`_bindUnknownQuotas`).
 */
export function unknownQuotaRowForGroup(
  groupKey: string,
  quotas: readonly SurveyQuota[],
  totalFielded: number,
): Option<SurveyQuota> {
  const [firstQuota] = quotas;
  if (!firstQuota?.hasInField) {
    return Option.none;
  }
  const achieved = quotas.reduce((sum, quota) => sum + quota.fielded, 0);
  const unknownFielded = totalFielded - achieved;
  if (unknownFielded <= 0) {
    return Option.none;
  }
  return Option.some({
    id: `${UNKNOWN_QUOTA_GROUP_KEY}-${groupKey}`,
    psQuotaId: UNKNOWN_QUOTA_GROUP_KEY,
    label: UNKNOWN_QUOTA_GROUP_KEY,
    hasCustomTitle: true,
    groupKey,
    locked: false,
    fielded: unknownFielded,
    // The "Unknown" bucket has no goal of its own; borrow a sibling's so the
    // row renders a comparable fielded/goal ratio against the group's target.
    goal: firstQuota.goal,
    requiredCount: firstQuota.requiredCount,
    currentlyOpen: 0,
    maximum: 0,
    allocationPercentage: 0,
    validClicks: 0,
    hasInField: true,
    isUnknown: true,
    suppliers: [],
    criteria: [],
    inProgress: 0,
  });
}
